import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import InputField from "../../Components/Common/InputField/InputField";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { saveEncrypted } from "../../Common Usage/localStorageUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePermission } from "Context/PermissionContext";

const SignIn = () => {
  const navigate = useNavigate();
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOTP] = useState("");
  const [otpErr, setOTPErr] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberErr, setPhoneNumberErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { setPermissions } = usePermission();

  const validatePhoneNumber = (number) => /^[6-9]\d{9}$/.test(number);

  // ---------------------- SEND OTP ----------------------
  const handleSignIn = () => {
    setIsLoading(true);

    if (!phoneNumber) {
      setPhoneNumberErr("Please Enter your Phone No.");
      setIsLoading(false);
      return;
    }
    if (!validatePhoneNumber(phoneNumber)) {
      setPhoneNumberErr("Please Enter A Valid Phone No.");
      setIsLoading(false);
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/staff/staff-sendotp`, {
        phoneNumber: `91${phoneNumber}`,
      })
      .then((response) => {
        if (response?.data?.success) {
          setShowOTP(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error?.response?.data?.message || "Something Went Wrong!");
      });
  };

  // ---------------------- VERIFY OTP ----------------------
  const handleVerifyOTP = () => {
    if (!otp) {
      setOTPErr("Please Enter Your OTP");
      return;
    }

    setIsLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/staff/staff-verifyotp`, {
        phoneNumber: `91${phoneNumber}`,
        otp: otp,
      })
      .then((response) => {
        setIsLoading(false);

        const staff = response?.data?.staffData;
        const role = staff?.rolePermission;

        if (!role || !role.rolename) {
          toast.error("No role assigned to this staff. Contact Admin.");
          return;
        }

        // ── Store auth data ──────────────────────────────────────────────
        saveEncrypted("HeartConnect-AuthToken", response?.data?.token);
        saveEncrypted("HeartConnect-StaffId", staff?._id);
        saveEncrypted("HeartConnect-StaffData", staff);

        // ── Store permissions ────────────────────────────────────────────
        const fullPermissions = role?.permission || {};
        setPermissions(fullPermissions);
        saveEncrypted(
          "HeartConnect-Permissions",
          JSON.stringify(fullPermissions)
        );

        // ── ✅ Store rolename so any component can read it without an API call ──
        saveEncrypted("HeartConnect-RoleName", role.rolename);

        console.log("📌 Stored Permissions:", fullPermissions);
        console.log("📌 Stored RoleName:", role.rolename);

        navigate("/admin/dashboard");
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("Verify OTP Error: " + error.message);
      });
  };

  return (
    <React.Fragment>
      <ToastContainer position="bottom-left" />

      <div className="mb-16 mt-28 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
        <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Admin Login
          </h4>
          <p className="mb-9 ml-1 text-base tracking-wide text-gray-600">
            {showOTP
              ? `Enter OTP sent to your phone number is ${phoneNumber}`
              : "Enter your phone number to get OTP!"}
          </p>

          {!showOTP && (
            <InputField
              variant="auth"
              extra="mb-4"
              label="Phone Number*"
              placeholder="Enter your phone number"
              id="phone"
              type="text"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                setPhoneNumberErr("");
              }}
            />
          )}

          {showOTP && (
            <InputField
              variant="auth"
              extra="mb-4"
              label="OTP*"
              placeholder="Enter OTP"
              id="otp"
              type="text"
              value={otp}
              onChange={(e) => {
                setOTP(e.target.value);
                setOTPErr("");
              }}
            />
          )}

          <div className="mb-2 text-sm tracking-wide text-red-700">
            {phoneNumberErr}
            {otpErr}
          </div>

          <div className="pt-2">
            {isLoading ? (
              <button className="linear flex w-full justify-center rounded-xl bg-[#c51369] py-[12px] tracking-wide">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={showOTP ? handleVerifyOTP : handleSignIn}
                className="linear w-full rounded-xl bg-[#c51369] py-[12px] text-base font-medium tracking-wide text-white transition duration-200 hover:bg-[#f54ea2]"
              >
                {showOTP ? "Verify OTP & Log In" : "Get OTP"}
              </button>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignIn;
